import { EDITABLE_NUMBER_CELL_ATTR } from 'components/common/EditableCell';

/** Marks a Nutrition rate field, so arrow keys can find the next one. */
export const NUTRITION_RATE_ATTR = 'data-nutrition-rate';

/**
 * Up / Down from a rate field moves to the previous or next editable rate in
 * the same table, in the order they appear — the same keys as the Planning
 * grid. Locked and saving rates are skipped. Leaving the field commits its
 * value as usual (on blur), and the next field opens for editing on focus.
 */
export const focusAdjacentRate = (
  direction: 'up' | 'down',
  from: HTMLElement
) => {
  const table = from.closest('table');
  const current = from.closest<HTMLElement>(`[${NUTRITION_RATE_ATTR}]`);
  if (!table || !current) return;

  const rates = Array.from(
    table.querySelectorAll<HTMLElement>(`[${NUTRITION_RATE_ATTR}]`)
  );
  const step = direction === 'up' ? -1 : 1;
  for (
    let index = rates.indexOf(current) + step;
    index >= 0 && index < rates.length;
    index += step
  ) {
    const target = rates[index].querySelector<HTMLElement>(
      `[${EDITABLE_NUMBER_CELL_ATTR}]:not([aria-disabled="true"])`
    );
    if (target) {
      target.focus();
      return;
    }
  }
};
